module.exports = __webpack_public_path__ + "static/media/Movieicon.ee72cf90.svg";